export * from "./FHIRQueryRequestHistory.js";
//# sourceMappingURL=index.js.map